import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TariffRentalDetailsDTO } from 'src/app/core/models/system/tariff/tariff-rental-details.dto';
import { TariffsRentalDetailsService } from 'src/app/core/services/utelize/system/tariff/tariffs-rental-details-service';
import { TariffsRentalService } from 'src/app/core/services/utelize/system/tariff/tariffs-rental-service';
import { TypesBillingServiceService } from 'src/app/core/services/utelize/system/type/types-billing-service-service';
import { TypesChargeService } from 'src/app/core/services/utelize/system/type/types-charge-service';
import { TypesCurrencyService } from 'src/app/core/services/utelize/system/type/types-currency-service';
import { TypesRecurringService } from 'src/app/core/services/utelize/system/type/types-recurring-service';
import { TypesTariffService } from 'src/app/core/services/utelize/system/type/types-tariff-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-tariffs-rental-details-modal-form',
  templateUrl: './tariffs-rental-details-modal-form.component.html',
  styleUrls: ['./tariffs-rental-details-modal-form.component.scss']
})

export class TariffsRentalDetailsModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Output() thisFormCancelled: EventEmitter<void>  =new EventEmitter<void>();
  @Output() thisFormSaved    : EventEmitter<number>=new EventEmitter<number>();
  
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('thisModalForm',      { static: false }) thisModalForm!     : TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                       
  private billingServiceTypeIdData!: IdAndDescriptionDTO[];
  private currencyTypeIdData!      : IdAndDescriptionDTO[];
  private feeChargeTypeIdData!     : IdAndDescriptionDTO[];
  private initialStatus            : string="Please complete the following details";
  private newRentalTariffDetails   : boolean=false;
  private tariffTypeIdData!        : IdAndDescriptionDTO[];
  private thisModalFormRef!        : NgbModalRef;
  private recurringTypeIdData!     : IdAndDescriptionDTO[];
  private rentalTariffDetails      : TariffRentalDetailsDTO | undefined;
  private rentalTariffDetailsId    : number | undefined;
  private rentalTariffIdData!      : IdAndDescriptionDTO[];
  private simChargeTypeIdData!     : IdAndDescriptionDTO[];
  
  public alertColourOrderStatus : string=AlertClassColour.Grey;
  public alertColourProgress    : string=AlertClassColour.Grey;
  public curUser                : SystemUserDTO;
  public formTitle              : string="Rental Tariff Detail";
  public progressInformation    : string=this.initialStatus;
  public progressInformationShow: boolean=false;
  public thisForm!              : UntypedFormGroup;
  public thisFormSubmitted      : boolean=false;

  //#region for Validators
  
  public tariffNameMaxLength: number=50;
  
  //#endregion  

  constructor(
    private authenticationService      : AuthenticationService,
    private configSystemService        : ConfigSystemService,
    private exceptionsService          : ExceptionsService,
    private formBuilder                : UntypedFormBuilder,
    private lastPassKillerService      : LastPassKillerService,
    private modalService               : NgbModal,
    private tariffsRentalDetailsService: TariffsRentalDetailsService,
    private tariffsRentalService       : TariffsRentalService,
    private typesBillingServiceService : TypesBillingServiceService,
    private typesChargeService         : TypesChargeService,
    private typesCurrencyService       : TypesCurrencyService,
    private typesRecurringService      : TypesRecurringService,
    private typesTariffService         : TypesTariffService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.alertColourProgress   =AlertClassColour.Grey;
      this.newRentalTariffDetails=false;
      this.progressInformation   =this.initialStatus;
      this.thisFormSubmitted     =false;
      this.rentalTariffDetails   =undefined;
      this.rentalTariffDetailsId =undefined;

      this.refreshFeeChargeTypeData();
      this.refreshRecurringTypeData();
      this.refreshRentalTariffData();
      this.refreshSimChargeTypeData();

      this.refreshBillingServiceTypeData();
      this.refreshCurrencyTypeData();
      this.refreshTariffTypeData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(rentalTariffDetailsId: number | undefined): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.enableDisableControls(false);

      if (rentalTariffDetailsId != undefined && <number>rentalTariffDetailsId>0) {
        this.rentalTariffDetailsId=rentalTariffDetailsId;

        this.getRentalTariffDetailsAndOpenModal();

      } else {
        this.newRentalTariffDetails=true;

        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getRentalTariffDetailsAndOpenModal() {
    try {
      this.tariffsRentalDetailsService.getById(<number>this.rentalTariffDetailsId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.rentalTariffDetails=data;
           
          this.populateFormFields(this.thisForm);
          this.openModal();
         },
        error: error => {
          this.thisFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.thisModalFormRef=this.modalService.open(this.thisModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm

  get formOfThis() {
    return this.thisForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);

      this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        this.addFormControl(formGroup, "feeChargeTypeId", undefined, [Validators.required]);
        this.addFormControl(formGroup, "recurringFee",    undefined, [Validators.required]);
        this.addFormControl(formGroup, "recurringTypeId", undefined, [Validators.required]);
        this.addFormControl(formGroup, "rentalTariffId",  undefined, [Validators.required]);
        this.addFormControl(formGroup, "setupFee",        undefined, [Validators.required]);
        this.addFormControl(formGroup, "simChargeTypeId", undefined, [Validators.required]);

        
        // this.addFormControl(formGroup, "active",               true, []);
        // this.addFormControl(formGroup, "billingServiceTypeId", undefined, [Validators.required]);
        // this.addFormControl(formGroup, "currencyTypeId",       undefined, [Validators.required]);
        // this.addFormControl(formGroup, "tariffName",           undefined, [Validators.required, Validators.maxLength(this.tariffNameMaxLength)]);
        // this.addFormControl(formGroup, "tariffTypeId",         undefined, [Validators.required]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm && this.rentalTariffDetails) {
        this.thisForm.controls["feeChargeTypeId"].setValue(this.rentalTariffDetails.feeChargeTypeID);
        this.thisForm.controls["recurringFee"].setValue(this.rentalTariffDetails.recurringFee);
        this.thisForm.controls["recurringTypeId"].setValue(this.rentalTariffDetails.recurringTypeID);
        this.thisForm.controls["rentalTariffId"].setValue(this.rentalTariffDetails.rentalTariffID);
        this.thisForm.controls["setupFee"].setValue(this.rentalTariffDetails.setupFee);
        this.thisForm.controls["simChargeTypeId"].setValue(this.rentalTariffDetails.simChargeTypeID);

        
        // this.thisForm.controls["active"].setValue(this.rentalTariffDetails.active);
        // this.thisForm.controls["billingServiceTypeId"].setValue(this.rentalTariffDetails.serviceID);
        // this.thisForm.controls["currencyTypeId"].setValue(this.rentalTariffDetails.currencyTypeID);
        // this.thisForm.controls["tariffName"].setValue(this.rentalTariffDetails.tariffName);
        // this.thisForm.controls["tariffTypeId"].setValue(this.rentalTariffDetails.tariffTypeID);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmitAttempt() {
    try {
      this.thisFormSubmitted=true;

      if (this.thisForm.valid) {
          this.thisFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmit() {
    try {
      this.prepareToSaveRentalTariffDetails();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="billingServiceTypeId") {
        return this.billingServiceTypeIdData;
      
      } else if (fieldName=="currencyTypeId") {
        return this.currencyTypeIdData;

      } else if (fieldName=="feeChargeTypeId") {
        return this.feeChargeTypeIdData;

      } else if (fieldName=="recurringTypeId") {
        return this.recurringTypeIdData;
        
      } else if (fieldName=="rentalTariffId") {
        return this.rentalTariffIdData;
        
      } else if (fieldName=="simChargeTypeId") {
        return this.simChargeTypeIdData;
        
      } else if (fieldName=="tariffTypeId") {
        return this.tariffTypeIdData;
        
      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="billingServiceTypeId") {
              this.billingServiceTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="currencyTypeId") {
              this.currencyTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="feeChargeTypeId") {
              this.feeChargeTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="recurringTypeId") {
              this.recurringTypeIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="rentalTariffId") {
              this.rentalTariffIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="simChargeTypeId") {
              this.simChargeTypeIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="tariffTypeId") {
              this.tariffTypeIdData=(data as IdAndDescriptionDTO[]);
              
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshBillingServiceTypeData() {
    try {
      this.getDropdownData(this.typesBillingServiceService.getIdAndDescription(), "billingServiceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCurrencyTypeData() {
    try {
      this.getDropdownData(this.typesCurrencyService.getIdAndDescription(), "currencyTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshFeeChargeTypeData() {
    try {
      this.getDropdownData(this.typesChargeService.getIdAndDescription(), "feeChargeTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshRecurringTypeData() {
    try {
      this.getDropdownData(this.typesRecurringService.getIdAndDescription(), "recurringTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshRentalTariffData() {
    try {
      this.getDropdownData(this.tariffsRentalService.getIdAndDescription(), "rentalTariffId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshSimChargeTypeData() {
    try {
      this.getDropdownData(this.typesChargeService.getIdAndDescription(), "simChargeTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public refreshTariffTypeData() {
    try {
      this.getDropdownData(this.typesTariffService.getIdAndDescription(), "tariffTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  private prepareToSaveRentalTariffDetails() {
    try
    {
      // let rentalTariffDetails: TariffRentalDetailsDTO={
      //   active        : this.thisForm.controls["active"].value,
      //   currencyTypeID: this.thisForm.controls["currencyTypeId"].value,
      //   enteredBy     : this.currUser.userId,
      //   id            : this.rentalTariffId ?? -1,
      //   serviceID     : this.thisForm.controls["billingServiceTypeId"].value,
      //   tariffName    : this.thisForm.controls["tariffName"].value,
      //   tariffTypeID  : this.thisForm.controls["tariffTypeId"].value
      // };


      //rentalTariffId
                  
      // this.saveRentalTariffDetails(rentalTariffDetails)
      // .pipe(
      //   catchError((error) => {
      //     return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
      //   })
      // )
      // .subscribe({
      //   next: data => {
      //     this.processComplete();
                  
      //     if (this.newRentalTariffDetails) {
      //       this.rentalTariffDetailsId=data["id"];
      //     }
          
      //     this.thisFormSaved.emit(this.rentalTariffDetailsId);
      //   },
      //   error: error => {
      //     this.alertColourProgress=AlertClassColour.Red;
      //     this.progressInformation=`Process cannot continue - ${error.message}`;
      //     this.exceptionsService.handleException(new Error(error));
      //   }
      // });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                  
  private saveRentalTariffDetails(rentalTariffDetails: TariffRentalDetailsDTO): Observable<TariffRentalDetailsDTO> {
    return this.tariffsRentalDetailsService.save(rentalTariffDetails);
  }

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newRentalTariffDetails ? "Rental Tariff Detail Created" : "Rental Tariff Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalFormClosed() {
    try {
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
